import { HorizontalBar } from "@reactchartjs/react-chart.js";
import { Card, CardTitle, Col, Row } from "reactstrap";
import { FormattedMessage } from "react-intl";

const CourseModulesResultsBar = ({ primaryData, secondaryData }) => {
  const options = {
    responsive: true,
    legend: {
      onClick: null,
    },
    indexAxis: "y",
    scales: {
      height: "300px",
      suggestedMax: 10,
      suggestedMin: 10,
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
  };

  return (
    <Col lg={12} xs={12} className="px-0 my-2">
      <Card body>
        <CardTitle>
          <FormattedMessage id="ModuleResultInCourse" />
        </CardTitle>
        <hr />
        <Row>
          <Col lg={6} sm={12}>
            <HorizontalBar data={primaryData} options={options} />
          </Col>
          <Col lg={6} sm={12}>
            <HorizontalBar data={secondaryData} options={options} />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default CourseModulesResultsBar;
